/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --background: var(--nve-sys-interaction-background);
  --padding: 0 var(--nve-ref-size-300);
  --border-radius: var(--nve-ref-border-radius-lg);
  --border: 0;
  --font-weight: var(--nve-ref-font-weight-semibold);
  --font-size: var(--nve-ref-font-size-200);
  --text-decoration: none;
  --cursor: pointer;
  --gap: var(--nve-ref-space-xxs);
  --height: var(--nve-ref-size-800);
  width: 100%;
}
